import classNames from 'classnames';

import { useIsMobile } from '../../../../hooks';

import styles from './SkeletonLoaderRow.module.scss';

interface SkeletonLoaderRowProps {
  rowItemsCount?: number;
  skeletonGrid?: string;
}

const gridClassMap: Record<string, string> = {
  FIVE_ROW_ITEMS_GRID: styles['wrapperSkeletonLoaderRow--fiveRowItemsGrid'],
  FOUR_ROW_ITEMS_GRID: styles['wrapperSkeletonLoaderRow--fourRowItemsGrid'],
};

const SkeletonLoaderRow = ({ rowItemsCount = 4, skeletonGrid }: SkeletonLoaderRowProps) => {
  const { isMobile } = useIsMobile();

  return (
    <div
      className={classNames(
        styles.wrapperSkeletonLoaderRow,
        skeletonGrid && gridClassMap[skeletonGrid],
      )}
    >
      <div className={styles.cell}>
        <div className={styles.skeletonLoaderLogoAndName}>
          <div className={styles.logoWrapper}>
            <div className={styles.logo} />
          </div>
          <div>
            <div className={styles.symbol} />
            <div className={styles.name} />
          </div>
        </div>
      </div>

      {isMobile ? (
        <>
          <div className={styles.cell}>
            <div className={styles.rowItem} />
            <div className={styles.rowItemEmpty} />
          </div>

          <div className={styles.cell}>
            <div className={styles.daily}>
              <div>
                <div
                  className={classNames(
                    styles.rowItem,
                    styles.bottomMargin,
                  )}
                />
                <div className={styles.rowItem} />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {Array.from({ length: rowItemsCount }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className={styles.cell} key={index}>
              <div className={styles.rowItem} />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default SkeletonLoaderRow;
